import React, { lazy } from 'react';
import IconOverview from '@/assets/images/menu/icon-overview.react.svg?react';
import { MenuIcon } from '@/presentation/components/menu-icon';
import { IRouteConfig } from '../types';

export const overviewRoutes = (): IRouteConfig[] => [
  {
    path: '/overview',
    exact: true,
    name: '数据总览',
    component: lazy(() => import('@/presentation/pages/overview')),
    icon: <MenuIcon icon={IconOverview} fontSize={16} />,
    sort: 100,
  },
  {
    path: '/overview-report',
    name: '数据总览',
    component: lazy(() => import('@/presentation/pages/overview')),
    hideInMenu: true,
    whitelisted: true,
  },
  {
    path: '/dashboard-edit',
    name: '看板编辑',
    component: lazy(() => import('@/presentation/pages/dashboard-editor')) as any,
    hideInMenu: true,
    whitelisted: true,
  },
];

export default overviewRoutes;
